export default "__VITE_ASSET__ByAuGs27__"